import "../styles/index.css";
import "../scss/main.scss";

import "@hotwired/turbo";
import "../scripts/popstate_handler";
import { Application } from "@hotwired/stimulus";
import TabsController from "../controllers/tabs_controller";
import SearchController from "../controllers/search_controller";
import ListGridViewToggleController from "../controllers/list_grid_view_toggle_controller";
import NavigationController from "../controllers/navigation_controller";
import CheckboxController from "../controllers/checkbox_controller"
import RangeController from "../controllers/range_controller"
import YearRangeController from "../controllers/year_range_controller"
import CareerSearchToolController from "../controllers/career_search_tool_controller"
import ScrollTriggerController from '../controllers/scroll_trigger_controller';
import OneItemSwiperController from '../controllers/one_item_swiper_controller';
import TwoItemsSwiperController from '../controllers/two_items_swiper_controller';
import SidebarScrollController from '../controllers/sidebar_scroll_controller';
import DropdownController from '../controllers/dropdown_controller';
import Tooltip from '../controllers/tooltip_controller';
import StudyAreaModalController from '../controllers/study_area_modal_controller';
import StudyAreaSliderController from '../controllers/study_area_slider_controller';

import { initFlowbite } from "flowbite";

window.Stimulus = Application.start();

window.Stimulus.register("tabs", TabsController);
window.Stimulus.register("listGridViewToggle", ListGridViewToggleController);
window.Stimulus.register("navigation", NavigationController);
window.Stimulus.register("checkbox", CheckboxController);
window.Stimulus.register("range", RangeController);
window.Stimulus.register("yearRange", YearRangeController);
window.Stimulus.register("careerSearchTool", CareerSearchToolController);
window.Stimulus.register("scrollTrigger", ScrollTriggerController);
window.Stimulus.register("search", SearchController);
window.Stimulus.register("oneItemSwiper", OneItemSwiperController);
window.Stimulus.register("twoItemsSwiper", TwoItemsSwiperController);
window.Stimulus.register("sidebarScroll", SidebarScrollController);
window.Stimulus.register("dropdown", DropdownController);
window.Stimulus.register("tooltip", Tooltip);
window.Stimulus.register("study-area-modal", StudyAreaModalController);
window.Stimulus.register("study-area-slider", StudyAreaSliderController);

document.addEventListener('turbo:load', function () {
  initFlowbite();
});